import {
  GenericErrorBoundary,
  LeftSideBar,
  MasterDetail,
  Navigation,
  UserMenuTopBar
} from 'components/core-v2'

import { DetailsRoutes } from '../components/details'
import { NotesList } from '../components/note-list'

export const NoteApprovalsPage = () => (
  <GenericErrorBoundary>
    <LeftSideBar
      leftElement={<Navigation />}
      mainElement={
        <GenericErrorBoundary>
          <MasterDetail detailChildren={<DetailsRoutes />} masterChildren={<NotesList />} />
        </GenericErrorBoundary>
      }
      topBarElement={<UserMenuTopBar />}
    />
  </GenericErrorBoundary>
)
